/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { ThirdPartiesViewModel } from './ThirdPartiesViewModel';
import {
    ThirdPartiesViewModelFromJSON,
    ThirdPartiesViewModelFromJSONTyped,
    ThirdPartiesViewModelToJSON,
} from './ThirdPartiesViewModel';

/**
 * 
 * @export
 * @interface ResultOfThirdPartiesViewModel
 */
export interface ResultOfThirdPartiesViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfThirdPartiesViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfThirdPartiesViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfThirdPartiesViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfThirdPartiesViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfThirdPartiesViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfThirdPartiesViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfThirdPartiesViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ThirdPartiesViewModel}
     * @memberof ResultOfThirdPartiesViewModel
     */
    data?: ThirdPartiesViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfThirdPartiesViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfThirdPartiesViewModel interface.
 */
export function instanceOfResultOfThirdPartiesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfThirdPartiesViewModelFromJSON(json: any): ResultOfThirdPartiesViewModel {
    return ResultOfThirdPartiesViewModelFromJSONTyped(json, false);
}

export function ResultOfThirdPartiesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfThirdPartiesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ThirdPartiesViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfThirdPartiesViewModelToJSON(value?: ResultOfThirdPartiesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ThirdPartiesViewModelToJSON(value.data),
        'Count': value.count,
    };
}

